import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { getValueAsFloat } from '/@/modules/core/app/helpers/NumberHelper';

export class ModelHasLiability extends BaseEntityModel {
  liabilityId?: number;
  category: string;
  shareOfOwnership: number;

  constructor(model: Partial<ModelHasLiability> = {}) {
    super(model);

    this.liabilityId = model.liabilityId;
    this.category = model.category as string;
    this.shareOfOwnership = model.shareOfOwnership as number;
  }

  get formattedShareOfOwnership(): number {
    return this.shareOfOwnership;
  }

  set formattedShareOfOwnership(newValue: number) {
    this.shareOfOwnership = getValueAsFloat(newValue);
  }

  /**
   * @returns {boolean}
   */
  get shareIsValid(): boolean {
    return this.shareOfOwnership >= 0 && this.shareOfOwnership <= 100;
  }

  clone(): ModelHasLiability {
    return ModelHasLiability.mapModel(this);
  }
}
